import { BaseApi, cancelInit, CancelTokenKeyCommit } from '@/main/baseApi';

import { DMS_MODULE, NAME, POLOZKY_HLASENI_O_SKODE } from './constants';

class HlaseniOSkodeProvider extends BaseApi {
	tableSchemaUrl() {
		return `${this.apiPath}${POLOZKY_HLASENI_O_SKODE}`;
	}

	tableDataUrl() {
		return `${this.apiPath}${POLOZKY_HLASENI_O_SKODE}Rows`;
	}

	protokolaHlaseniOSkode(filter: {}) {
		return this.fetchPdf(`/${DMS_MODULE}/Reports/GetSkodaHlaspaProtokolReport`, filter);
	}
}

export const apiProvider = new HlaseniOSkodeProvider(DMS_MODULE, NAME);
